import { Component, h, Event, EventEmitter, Build } from '@stencil/core';
import state from '../../store/store';
import QrScanner from 'qr-scanner';

declare var UIkit;

@Component({
    tag: 'app-qr',
})
export class AppQR {

    @Event() detected: EventEmitter<any>;

    private qrScanner: any;
    private qrModal: any;

    async componentDidLoad() {
        const el = this;
        if (Build.isBrowser) UIkit.util.on('#qr-modal', 'show', () => {
            if (!el.qrScanner) el.initScanner();
            el.qrScanner.start()
        })

        if (Build.isBrowser) UIkit.util.on('#qr-modal', 'hide', () => {
            el.qrScanner.stop()
        })
    }


    initScanner() {

        if (!state.browser['BarcodeDetector']) return;
        if (this.qrScanner) return;

        this.qrModal = UIkit.modal('#qr-modal');
        const video: any = document.querySelector('#qr-scanner');
        const el = this;
        const qrScannerOptions = {
            maxScansPerSecond: 2,
            highlightScanRegion: true
        }
        const qrScanner = new QrScanner(video, ({ data }) => {
            el.detected.emit(data)
            el.qrModal.hide()
        }, qrScannerOptions);

        this.qrScanner = qrScanner;

    }

    disconnectedCallback() {
        if (this.qrScanner) this.qrScanner.destroy();
        if (this.qrModal) this.qrModal.$destroy(true);
    }

    render() {
        return (
            <div>
                <slot />
                <div>
                    <div id="qr-modal" class="uk-modal-container" uk-modal>
                        <div class="uk-modal-dialog uk-width-1-1 uk-height-1-1 uk-margin-auto-vertical" style={{ 'background': 'none' }}>
                            <button class="uk-modal-close-outside" type="button" uk-close></button>
                            <video id="qr-scanner" class="uk-width-1-1 uk-height-1-1 uk-relative" muted></video>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
